import ScrollTop from "./ScrollTop.js";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { COUNTRY_CODE_URL, NAME_URL } from "../base_url.js";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const BorderingCountries = ({ country }) => {
  const [border, setBorder] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    fetch(`${COUNTRY_CODE_URL}/${country}`)
      .then((res) => res.json())
      .then((data) => {
        setBorder(data);
      })
      .finally(() => setIsLoading(false));
  }, [country]);

  return (
    <>
      {isLoading ? null : (
        <Link
          to={`/country/${border[0].name.common}`}
          className="border-button-container"
        >
          {border[0].name.common}
        </Link>
      )}
    </>
  );
};

const DetailedPage = (props) => {
  const [countryDetails, setCountryDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    fetch(`${NAME_URL}/${props.match.params.country}`)
      .then((res) => res.json())
      .then((data) => {
        setCountryDetails(data);
      })
      .finally(() => setIsLoading(false));
  }, [props.match.params.country]);

  return (
    <main className="main-container">
      <ScrollTop />
      <div className="content-container">
        <div className="back-button">
          <Link to="/">
            <FontAwesomeIcon icon={faArrowLeft} />
            Back
          </Link>
        </div>
        {isLoading ? (
          <h1>Loading...</h1>
        ) : (
          <>
            <div className="country-detail">
              <img
                src={countryDetails[0].flags.svg}
                alt={countryDetails[0].name.common}
              />
              <div className="country-detail-content">
                <h2>{countryDetails[0].name.common}</h2>
                <div className="country-detail-stats">
                  <div className="country-detail-stats-left">
                    <p>
                      <span className="bold">Official Name: </span>
                      {countryDetails[0].name.official}
                    </p>
                    <p>
                      <span className="bold">Population: </span>
                      {countryDetails[0].population.toLocaleString("en-US")}
                    </p>
                    <p>
                      <span className="bold">Region: </span>
                      {countryDetails[0].region}
                    </p>
                    <p>
                      <span className="bold">Sub Region: </span>
                      {countryDetails[0].subregion}
                    </p>
                    <p>
                      <span className="bold">Capital: </span>
                      {countryDetails[0].capital[0]}
                    </p>
                  </div>

                  <div className="country-detail-stats-right">
                    <p>
                      <span className="bold">Continents: </span>
                      {countryDetails[0].continents}
                    </p>
                    <p>
                      <span className="bold">Currencies: </span>
                      {Object.keys(countryDetails[0].currencies).map(
                        (currencyCode, index, arr) => {
                          const { name, symbol } =
                            countryDetails[0].currencies[currencyCode];
                          if (arr.length - 1 === index) {
                            return (
                              <span key={name}>
                                {name} ({symbol})
                              </span>
                            );
                          } else {
                            return (
                              <span key={name}>
                                {name} ({symbol}),{" "}
                              </span>
                            );
                          }
                        }
                      )}
                    </p>
                    <p>
                      <span className="bold">Languages: </span>
                      {Object.keys(countryDetails[0].languages).map(
                        (languageCode, index, arr) => {
                          const name =
                            countryDetails[0].languages[languageCode];
                          if (arr.length - 1 === index) {
                            return name;
                          } else {
                            return `${name}, `;
                          }
                        }
                      )}
                    </p>
                  </div>
                </div>

                <div className="country-detail-borders">
                  <div className="bold border">Border Countries:</div>
                  <div className="border-container">
                    {countryDetails[0].borders.length === 0 ? (
                      <p>None</p>
                    ) : (
                      countryDetails[0].borders.map((item) => (
                        <BorderingCountries country={item} key={item} />
                      ))
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </main>
  );
};

export default DetailedPage;
